import { ArrowUpRight } from 'lucide-react';
import { motion } from 'framer-motion';
import type { ProfileLink } from '../data/profile';
import { getIcon } from '../utils/iconMap';
import { getLinkTargetProps } from '../utils/links';

type BioLinkProps = {
  link: ProfileLink;
  index: number;
};

export function BioLink({ link, index }: BioLinkProps) {
  const Icon = getIcon(link.icon);

  return (
    <motion.a
      className="bio-link"
      href={link.href}
      aria-label={`${link.title}: ${link.helper}`}
      initial={{ opacity: 0, y: 12 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.36, delay: 0.12 + index * 0.05, ease: 'easeOut' }}
      whileHover={{ y: -2 }}
      whileTap={{ scale: 0.985 }}
      {...getLinkTargetProps(link.href)}
    >
      <span className="bio-link__icon">
        <Icon size={20} strokeWidth={1.8} />
      </span>
      <span className="bio-link__content">
        <strong>{link.title}</strong>
        <small>{link.helper}</small>
      </span>
      <ArrowUpRight className="bio-link__arrow" size={18} strokeWidth={1.8} />
    </motion.a>
  );
}
